export const TRIAL_BANNER_COPY = {
  tag: {
    daysLeft: (daysLeft: number, pluralisedDay: string) =>
      `${daysLeft} ${pluralisedDay} left`,
  },
  text: {
    PLG: {
      message: (daysLeft: number, pluralisedDay: string) =>
        `Your trial ends in ${daysLeft} ${pluralisedDay}. Want to see this fully configured and tailored to your business?`,
      contactText: 'Book a Demo',
    },
    OpenTable: {
      message: (daysLeft: number, pluralisedDay: string) =>
        `Your trial ends in ${daysLeft} ${pluralisedDay}. Talk to PolyAI about your next steps.`,
      contactText: 'Talk to PolyAI',
      contactToastTitle: 'Email copied to clipboard',
      contactToastMessage:
        "We've copied our support email to your clipboard. Get in touch to discuss your next steps with PolyAI.",
      contactEmail: 'restaurantsupport@poly-ai.com',
    },
  },
} as const;
